module.exports = __webpack_public_path__ + "img/logo.78950d4a.svg";